module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epi01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page04"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page05"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("Phantoms are fingerprints of the soul.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Anonymous, Babylon, 2500 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("B.C")]), _vm._v(".")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 66
// module chunks = 0